<template>
  <a-modal :visible="visible" :footer="null" :closable="false" :bodyStyle="{ padding: 0 }" width="440px" centered
    @cancel="handleClose" class="service-modal">
    <div class="service-modal-content" v-if="service">
      <!-- Close Button -->
      <button class="service-modal-close" @click="handleClose">
        <a-icon type="close" />
      </button>

      <!-- Header / Icon Area -->
      <div class="service-modal-header">
        <div class="service-modal-icon-ring" :style="{ background: service.bgColor }">
          <img v-if="service.iconUrl" :src="service.iconUrl" :alt="service.title" class="service-modal-icon-img" />
          <a-icon v-else :type="service.icon || 'appstore'" class="service-modal-icon"
            :style="{ color: service.iconColor }" />
        </div>
      </div>

      <!-- Body -->
      <div class="service-modal-body">
        <!-- Title -->
        <h2 class="service-modal-title">{{ service.title }}</h2>

        <!-- Description (HTML) -->
        <div class="service-modal-desc-label">
          <a-icon type="read" />
          <span>Description</span>
        </div>
        <div class="service-modal-desc-content" v-html="service.htmlDescription || service.description"></div>
      </div>

      <!-- Footer -->
      <div class="service-modal-footer" v-if="service.link">
        <a :href="service.link" target="_blank" rel="noopener noreferrer" class="service-modal-open-btn">
          <a-icon type="link" />
          Open Service
        </a>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "ModalService",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    service: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.service-modal-content {
  position: relative;
}

/* Close Button */
.service-modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  background: #f0f0f0;
  color: #8c8c8c;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.service-modal-close:hover {
  background: #e0e0e0;
  color: #333;
}

/* Header / Icon */
.service-modal-header {
  display: flex;
  justify-content: center;
  padding: 36px 0 20px;
  background: linear-gradient(135deg, #f8f6ff 0%, #eef2ff 100%);
  border-bottom: 1px solid #f0f0f0;
}

.service-modal-icon-ring {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(80, 43, 128, 0.12);
  border: 4px solid #fff;
}

.service-modal-icon {
  font-size: 38px !important;
}

.service-modal-icon-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
  border-radius: 8px;
}

/* Body */
.service-modal-body {
  padding: 24px 28px 20px;
}

.service-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.4;
}

.service-modal-desc-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.service-modal-desc-content {
  background: #f9f9fb;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 16px 18px;
  font-size: 14px;
  line-height: 1.7;
  color: #595959;
}

.service-modal-desc-content>>>p {
  margin-bottom: 8px;
}

.service-modal-desc-content>>>ul,
.service-modal-desc-content>>>ol {
  padding-left: 20px;
  margin-bottom: 8px;
}

.service-modal-desc-content>>>a {
  color: #502b80;
  text-decoration: underline;
}

.service-modal-desc-content>>>strong {
  color: #1a1a2e;
}

/* Footer */
.service-modal-footer {
  padding: 0 28px 24px;
}

.service-modal-open-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 0;
  background: #502b80;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.25s ease;
  letter-spacing: 0.3px;
}

.service-modal-open-btn:hover {
  background: #3d1f63;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(80, 43, 128, 0.3);
}

/* Responsive */
@media (max-width: 480px) {
  .service-modal-icon-ring {
    width: 72px;
    height: 72px;
  }

  .service-modal-icon {
    font-size: 30px !important;
  }

  .service-modal-body {
    padding: 20px;
  }

  .service-modal-title {
    font-size: 18px;
  }

  .service-modal-footer {
    padding: 0 20px 20px;
  }
}
</style>

<style>
/* Global modal overrides (unscoped) */
.service-modal .ant-modal-body {
  padding: 0 !important;
  border-radius: 16px;
  overflow: hidden;
}

.service-modal .ant-modal-content {
  border-radius: 16px !important;
  overflow: hidden;
}
</style>
